var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-layout',{attrs:{"menu":_vm.menu,"title":"Community Hub"}},[_c('router-view'),_c('base-modal-wrapper')],1)}
var staticRenderFns = []

export { render, staticRenderFns }